var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('appMeetingResolutionsTable',{attrs:{"meeting-id":_vm.meetingId,"building-id":_vm.buildingId},on:{"hideParentActionButtons":function($event){return _vm.$emit('hideParentActionButtons', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }